import type { PluginClientModule } from "@d12labs/plugins/types";
import { manifest } from "../manifest";
import { createPluginRoutes } from "./routes";

export const client: PluginClientModule = { manifest, createRoutes: createPluginRoutes };
